import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _getSiteTranslatablesPropertiesRequest = {};
var _getSiteTranslatablesPropertiesResponse = {};
var _translateSiteRequest = {};
var _translateSiteResponse = {};
function resolveComWixpressMultilingualSitetranslatorV2SiteTranslatorV2Url(opts) {
    var domainToMappings = {
        'editor._base_domain_': [
            {
                srcPath: '/_api/site-translator',
                destPath: '',
            },
            {
                srcPath: '/_api/site_translator/v2/properties',
                destPath: '/v2/properties',
            },
            {
                srcPath: '/_api/site_translator/v2/translate',
                destPath: '/v2/translate',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/site-translator',
                destPath: '',
            },
            {
                srcPath: '/_api/site_translator/v2/properties',
                destPath: '/v2/properties',
            },
            {
                srcPath: '/_api/site_translator/v2/translate',
                destPath: '/v2/translate',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/site-translator',
                destPath: '',
            },
            {
                srcPath: '/_api/site_translator/v2/properties',
                destPath: '/v2/properties',
            },
            {
                srcPath: '/_api/site_translator/v2/translate',
                destPath: '/v2/translate',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/site-translator',
                destPath: '/api',
            },
            {
                srcPath: '/_api/site-translator/v2/properties',
                destPath: '/v2/properties',
            },
            {
                srcPath: '/_api/site-translator/v2/translate',
                destPath: '/v2/translate',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/multilingual/v2/site-translator',
                destPath: '/v2',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/site_translator/v2/properties',
                destPath: '/v2/properties',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Start a task to auto-translate all site content that hasn't been translated yet */
export function translateSite(payload) {
    var _a = serializer(_translateSiteRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_translateSiteResponse, {}).fromJSON;
    function __translateSite(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.multilingual.sitetranslator.v2.site_translatable_properties',
            method: 'POST',
            methodFqn: 'com.wixpress.multilingual.sitetranslator.v2.SiteTranslatorV2.TranslateSite',
            url: resolveComWixpressMultilingualSitetranslatorV2SiteTranslatorV2Url({
                protoPath: '/v2/translate',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __translateSite.fromReq = fromReq;
    __translateSite.__isAmbassador = true;
    return __translateSite;
}
/** Receive the site's translation status */
export function getSiteTranslatablesProperties(payload) {
    var _a = serializer(_getSiteTranslatablesPropertiesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getSiteTranslatablesPropertiesResponse, {}).fromJSON;
    function __getSiteTranslatablesProperties(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.multilingual.sitetranslator.v2.site_translatable_properties',
            method: 'POST',
            methodFqn: 'com.wixpress.multilingual.sitetranslator.v2.SiteTranslatorV2.GetSiteTranslatablesProperties',
            url: resolveComWixpressMultilingualSitetranslatorV2SiteTranslatorV2Url({
                protoPath: '/v2/properties',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getSiteTranslatablesProperties.fromReq = fromReq;
    __getSiteTranslatablesProperties.__isAmbassador = true;
    return __getSiteTranslatablesProperties;
}
//# sourceMappingURL=http.impl.js.map